// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__whLmT","gridMenu":"Menu_gridMenu__nWsqy","linksMenu":"Menu_linksMenu__8Gxj5","logo":"Menu_logo__4-rCI"};